import React from "react";
import styled from "styled-components";

interface SignImageProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  imgWrapperProps?: React.HTMLAttributes<HTMLDivElement>;
}

const SignImage = ({ src, imgWrapperProps, ...rest }: SignImageProps) => {
  return (
    <SignImageLayout {...imgWrapperProps}>
      {src && <img src={src} {...rest} alt="sign-image" />}
    </SignImageLayout>
  );
};

export default SignImage;

const SignImageLayout = styled.div`
  border-radius: 5px;
  border: 1px dashed ${({ theme }) => theme.color.stroke.dark};
  background: ${({ theme }) => theme.color.background.default};
  width: 13.8rem;
  height: 13.8rem;
  display: flex;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
    object-fit: contain;
  }
`;
